import React from 'react';
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import DataTable from '../DataTable/DataTable';

// Titled table card (title, optional search box and action buttons). See DataTable.
// Every caller's action is an "Add …" button; they all get the same + icon.
export default function CustomTable({
  tableHead, itemComponent, count, handleChangePage, page,
  tableName, icons, onIconClick, noDataText, pages, search, loading,
  serverSide, totalCount, pageSize, onPageSizeChange,
}) {
  return (
    <DataTable
      flush
      loading={loading}
      title={tableName}
      search={search}
      actions={(icons || []).map((item) => ({ ...item, icon: AddRoundedIcon }))}
      onActionClick={onIconClick}
      tableHead={tableHead}
      itemComponent={itemComponent}
      noDataText={noDataText}
      count={count}
      page={page}
      handleChangePage={handleChangePage}
      paginate={pages !== false}
      serverSide={serverSide}
      totalCount={totalCount}
      pageSize={pageSize}
      onPageSizeChange={onPageSizeChange}
    />
  );
}
